import * as S from '../styled'
import React, { useEffect } from 'react'
import { useFavoriteApi } from 'src/features/favorite/hooks'

export interface FavoriteIndicateMobileProps {
    goodId: number
}

export function FavoriteIndicateMobile({ goodId }: FavoriteIndicateMobileProps) {
    const { toggle, isLiked } = useFavoriteApi(goodId)

    return (
        <S.Container onClick={toggle}>
            <S.FavoriteIcon
                src={
                    isLiked
                        ? `${process.env.NEXT_PUBLIC_BASE_PATH}/images/mobile_favorite_border_red.svg`
                        : `${process.env.NEXT_PUBLIC_BASE_PATH}/images/mobile_favorite_border.svg`
                }
            />
        </S.Container>
    )
}
